module.exports = __webpack_public_path__ + "static/keyboardshortcut-container-dont-fdf4bd73b2f4cd1ca0fe8ec223bd881f.png";